var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditstoredetailsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.341 5.56748L21.6744 0.567768C21.6165 0.395293 21.5036 0.246538 21.3532 0.14422C21.2027 0.0419031 21.0229 -0.00835126 20.8412 0.00113323H2.50886C2.32715 -0.00835126 2.14733 0.0419031 1.99686 0.14422C1.8464 0.246538 1.73356 0.395293 1.67558 0.567768L0.00900396 5.56748C-0.00300132 5.65596 -0.00300132 5.74566 0.00900396 5.83414V10.8339C0.00900396 11.0549 0.0967963 11.2668 0.253068 11.4231C0.409339 11.5793 0.621289 11.6671 0.84229 11.6671H1.67558V20H3.34215V11.6671H8.34187V20H21.6744V11.6671H22.5077C22.7287 11.6671 22.9407 11.5793 23.097 11.4231C23.2532 11.2668 23.341 11.0549 23.341 10.8339V5.83414C23.353 5.74566 23.353 5.65596 23.341 5.56748ZM20.0079 18.3334H10.0084V11.6671H20.0079V18.3334ZM21.6744 10.0006H18.3413V6.66742H16.6747V10.0006H12.5083V6.66742H10.8417V10.0006H6.67529V6.66742H5.00872V10.0006H1.67558V5.96746L3.10883 1.66771H20.2412L21.6744 5.96746V10.0006Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditstoredetailsicon);
export default __webpack_public_path__ + "static/media/editstoredetailsicon.cb747565b2129a97fb1f2621f05f6944.svg";
export { ForwardRef as ReactComponent };